export const SURVEY_YEAR = 2025;

const MINOR_TRANSLATION_PREFIX = "benchmarking.evaluations.key-figures.minor";

export const MINOR_KPI_TRANSLATION_KEYS = {
  sectionTitle: `${MINOR_TRANSLATION_PREFIX}.sec2Title`,
  directToIndirect: `${MINOR_TRANSLATION_PREFIX}.kpiDirectToIndirect`,
};

const KPI_TRANSLATION_PREFIX = "benchmarking.evaluations.key-figures.scorecards";

export const KPI_SCORECARD_TRANSLATION_KEYS = {
  formulaLabel: "benchmarking.evaluations.benchmark.formula",
  interpretationLabel: "benchmarking.evaluations.benchmark.interpretation",
  sectionTitle: `${KPI_TRANSLATION_PREFIX}.section-title`,
  displayMyData: `${KPI_TRANSLATION_PREFIX}.display-my-data`,
  legend: {
    label: `${KPI_TRANSLATION_PREFIX}.legend.label`,
    title: `${KPI_TRANSLATION_PREFIX}.legend.title`,
    description: `${KPI_TRANSLATION_PREFIX}.legend.description`,
    normalDistribution: `${KPI_TRANSLATION_PREFIX}.legend.normal-distribution`,
    mean: `${KPI_TRANSLATION_PREFIX}.legend.mean`,
    sd: `${KPI_TRANSLATION_PREFIX}.legend.standard-deviation`,
    higher: `${KPI_TRANSLATION_PREFIX}.legend.higher-is-better`,
    lower: `${KPI_TRANSLATION_PREFIX}.legend.lower-is-better`,
    belowFair: `${KPI_TRANSLATION_PREFIX}.legend.below-fair`,
    fair: `${KPI_TRANSLATION_PREFIX}.legend.fair`,
    good: `${KPI_TRANSLATION_PREFIX}.legend.good`,
    veryGood: `${KPI_TRANSLATION_PREFIX}.legend.very-good`,
    close: `${KPI_TRANSLATION_PREFIX}.legend.close`,
  },
};

const kpiTranslationKeys = (slug) => ({
  titleKey: `${KPI_TRANSLATION_PREFIX}.kpis.${slug}.title`,
  formulaKey: `${KPI_TRANSLATION_PREFIX}.kpis.${slug}.formula`,
  interpretationKey: `${KPI_TRANSLATION_PREFIX}.kpis.${slug}.interpretation`,
});

const KPI_DEFINITIONS = [
  {
    id: "totalCostsRatio",
    keyFigure: "total_cost_percent_fee_revenue",
    direction: "lower",
    unit: "percent",
    ...kpiTranslationKeys("total-costs-ratio"),
  },
  {
    id: "revenuePerFte",
    keyFigure: "fee_revenue_per_total_fte",
    direction: "higher",
    unit: "currency",
    ...kpiTranslationKeys("revenue-per-fte"),
  },
  {
    id: "totalCostsPerFte",
    keyFigure: "total_cost_per_total_fte",
    direction: "lower",
    unit: "currency",
    ...kpiTranslationKeys("total-costs-per-fte"),
  },
  {
    id: "overheadRatio",
    keyFigure: "overhead_percent_direct_labor_cost",
    direction: "lower",
    unit: "percent",
    ...kpiTranslationKeys("overhead-ratio"),
  },
  {
    id: "fullCostPerHour",
    keyFigure: "total_cost_per_project_hour",
    direction: "lower",
    unit: "currencyPerHour",
    ...kpiTranslationKeys("full-cost-per-hour"),
  },
  {
    id: "productivityRate",
    keyFigure: "project_hours_per_net_working_time",
    direction: "higher",
    unit: "percent",
    ...kpiTranslationKeys("productivity-rate"),
  },
];

const minorTranslationKeys = (name) => ({
  titleKey: `${MINOR_TRANSLATION_PREFIX}.${name}`,
  formulaKey: `${MINOR_TRANSLATION_PREFIX}.${name}Form`,
  interpretationKey: `${MINOR_TRANSLATION_PREFIX}.${name}Desc`,
});

const MINOR_KPI_DEFINITIONS = [
  {
    id: "projectUtilizationRate",
    keyFigure: "project_hours_per_nominal_time",
    direction: "higher",
    unit: "percent",
    decimals: 1,
    ...minorTranslationKeys("kpiProjectUtilRate"),
    interpretationKey: null,
  },
  {
    id: "capacityUtilizationRate",
    keyFigure: "net_working_time_per_nominal_time",
    direction: "higher",
    unit: "percent",
    decimals: 1,
    ...minorTranslationKeys("kpiCapacityUtilRate"),
  },
  {
    id: "indirectLaborShare",
    keyFigure: "indirect_labor_fte_to_total_fte_ratio",
    direction: "lower",
    unit: "percent",
    decimals: 1,
    secondaryMetric: "directToIndirect",
    ...minorTranslationKeys("kpiIndirectLabor"),
  },
  {
    id: "projectHoursPerFte",
    keyFigure: "project_hour_per_total_fte",
    direction: "higher",
    unit: "hours",
    decimals: 0,
    ...minorTranslationKeys("kpiProjectHoursPerFTE"),
  },
];

export function getOrderedKpiDefinitions(translate, group = "major") {
  const definitions = group === "minor" ? MINOR_KPI_DEFINITIONS : KPI_DEFINITIONS;

  return definitions.map((definition, displayOrder) => ({
    ...definition,
    displayOrder,
    title: translate(definition.titleKey),
    formula: translate(definition.formulaKey),
    interpretation: definition.interpretationKey ? translate(definition.interpretationKey) : "",
  }));
}
